import axios from 'axios';
import getEnvironment from '../functions/get.environment';
import useMockLoginApi from './use.mock.login.api';
import useTrait from './use.trait';
import local from '../classes/local';
import the from '../objects/the';
import use from '../objects/use';

export default function useLoginApi() {
    const mock = useMockLoginApi();
    const redirectUri = useTrait('');
    const relay = useTrait('');
    const tracker = use.inflightTracker;
   
    const login = (username = '', password = '', clientId, params, headers, onSuccess, errorCallback = the.emptyFunction) => {
        const url = '/signin';
        if (tracker.isAlreadyInflight(url))
            return;
        tracker.addApiCall(url);
        redirectUri.set(params.redirect_uri || '');
        let newRelayValue = params.relay || '';
        if (!newRelayValue && clientId.startsWith('mbp'))
            newRelayValue = local.getItem('language', 'English') === 'English' ? 'en-us' : 'es-mx';
        relay.set(newRelayValue);
        if (!username || !password) {
            throw new Error('SSO-0');
        }
        if (getEnvironment() === 'localhost')
            return mock.login(username, password, errorCallback);
        headers.withCredentials = true;
        axios.post(
            process.env.REACT_APP_LOGIN_API_ENDPOINT + url,
            {
                username,
                password,
                client_id: clientId,
                relay: relay.get(),
                redirect_uri: redirectUri.get(),
            },
            headers,
        ).then(response => {
            tracker.removeApiCall(url);
            document.location.href = process.env.REACT_APP_LOGIN_APPEND_LOCATION + response.data.location;
            onSuccess();
        }).catch(e => {
            tracker.removeApiCall(url);
            errorCallback(e);
        });
    };
   
    return {
        login,
    };
}